import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-near-me",
  templateUrl: "./med-icon-near-me.component.html",
})
export class MedIconNearMeComponent extends SvgMixinComponent {}
